import { Component } from "react";
import { Button } from "reactstrap";
import { signOutAction } from "../../actions/authActions";
import { connect } from "react-redux";
import axios from "../../services/api/api";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
class ButtonSendActivationMail extends Component {
  sendActivationMail = () => {
    axios
      .post(
        `/User/SendActivationMail?email=${encodeURIComponent(
          this.props.user.email
        )}`
      )
      .then((res) => {
        toast.success(
          "Det har skickats ett nytt aktiveringsmail till användaren"
        );
      })
      .catch((err) => {
        toast.warn(
          `Det gick inte att skicka ut ett nytt aktiveringsmail till användaren`
        );
      });
  };

  render() {
    return (
      <Button
        outline
        disabled={this.props.user.activatedAccount}
        title={
          this.props.user.activatedAccount
            ? "Användaren har skapat sitt konto. Har användaren glömt sitt lösenord? Användaren får då använda 'Glömt lösenord'-länken på inloggningssidan för att byta lösenord"
            : "Användaren har inte aktiverat sitt konto. Klicka här för att skicka ett nytt aktiveringsmail"
        }
        size="sm"
        color="info"
        className={this.props.leftAlign ? "float-start" : "float-end"}
        onClick={this.sendActivationMail}
      >
        <FontAwesomeIcon icon="envelope" className="me-1" />
        <FontAwesomeIcon icon="retweet" />
        {this.props.printButtonText ? " Skicka ett nytt aktiveringsmail" : ""}
      </Button>
    );
  }
}

export default connect(null, { signOutAction })(ButtonSendActivationMail);
